/* Lupin Gold referral capture (29/09/2026, Goldie). ?ref=LGxxxx is kept for 60 days; when the
   Klaviyo signup form is submitted it is written to the profile as lg_referred_by. No UI. */
(function () {
  try {
    var KEY = 'lg_ref', DAYS = 60;
    var ref = new URLSearchParams(window.location.search).get('ref');
    if (ref && /^LG[0-9A-Z]{3,20}$/i.test(ref)) {
      localStorage.setItem(KEY, JSON.stringify({ c: ref.toUpperCase(), t: Date.now() }));
    }
    var saved = function () {
      try {
        var o = JSON.parse(localStorage.getItem(KEY) || 'null');
        return o && Date.now() - o.t < DAYS * 864e5 ? o.c : null;
      } catch (e) { return null; }
    };
    window.addEventListener('klaviyoForms', function (e) {
      if (!e.detail || e.detail.type !== 'submit') return;
      var code = saved();
      if (!code) return;
      var props = { lg_referred_by: code };
      var email = e.detail.metaData && e.detail.metaData.$email;
      if (email) props.$email = email;
      var k = window.klaviyo || (window._learnq = window._learnq || []);
      k.push(['identify', props]);
    });
  } catch (e) { /* never break the page */ }
})();

/* Credit popup login (05/10/2026, Penny). After a popup sign-up, the popup's LOG IN button opens the
   store login with the email already filled in (login_hint). Without this the button still goes to
   the login page, just with the email box empty. */
(function () {
  try {
    var email = null;
    window.addEventListener('klaviyoForms', function (e) {
      var m = e.detail && e.detail.type === 'submit' && e.detail.metaData;
      if (m && m.$email) email = m.$email;
    });
    document.addEventListener('click', function (ev) {
      if (!email || !ev.target.closest) return;
      var b = ev.target.closest('button');
      if (!b || !b.closest('.klaviyo-form') || !/^\s*log in/i.test(b.textContent)) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      window.location.href = '/customer_authentication/login?return_to=/&login_hint=' + encodeURIComponent(email);
    }, true);
  } catch (e) { /* never break the page */ }
})();
